import { Component } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-opportunities-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './opportunities.page.html',
  styleUrl: './opportunities.page.scss',
})
export class OpportunitiesPage {}
